<template>
  <div class="w-full border rounded-lg px-4 lg_px-8 py-12">
    <h1 class="text-center text-2xl font-semibold leading-none mb-12">Log In to Your Account</h1>
    <LoginForm @submit="$emit('submit', $event)" />
    <p class="text-center mt-6">
      <Button variant="link" class="text-sm" @click="emit('toggle-login-form')">Back to Log In Options</Button>
    </p>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['toggle-login-form', 'submit'])
</script>
